function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M319.93079,670.93359C369.26868,645.35742,471.2605,602.45068,600,602.45068s230.7312,42.90674,280.06909,68.48291c48.03223,24.89966,86.66126,54.25776,104.85785,78.21131,6.633-9.0279-3.10223-169.64246-30.04388-233.33972A516.23466,516.23466,0,0,0,478.81982,200.25a273.27049,273.27049,0,0,0-194.50537,80.56689q-1.62356,1.62357-3.21669,3.26932c-57.01738,58.89946-83.64047,140.84441-73.92029,222.24249,6.92036,57.952,23.97575,179.16517,48.07418,204.86612A458.813,458.813,0,0,1,319.93079,670.93359Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#898989"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M689.00334,238.75c-75.14014-.00677-133.99878-13.62878-133.99721-31.01208.00094-10.42188,20.85774-19.71882,57.22227-25.50607a1,1,0,1,1,.31428,1.97512c-34.25538,5.452-55.53573,14.46863-55.53655,23.53113-.00142,15.71973,60.44587,29.00545,131.99739,29.0119s132.00119-13.26837,132.00261-28.9881c.00082-9.10059-21.41389-18.143-55.88752-23.59781a1.00008,1.00008,0,1,1,.31268-1.97556c36.59054,5.78992,57.57578,15.11115,57.57484,25.57355C823.00456,225.14538,764.14347,238.75677,689.00334,238.75Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M622.52429,244.58239a76.98278,76.98278,0,0,0,133.14994-.32351A1211.97886,1211.97886,0,0,1,622.52429,244.58239Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#5958a5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M763.04676,222.8796a76.997,76.997,0,1,0-147.85749.78574A572.23315,572.23315,0,0,0,763.04676,222.8796Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#5958a5"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 501.79904,
  cy: 34,
  r: 9,
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 454.79399,
  cy: 70.99739,
  r: 15,
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 483.79904,
  cy: 142,
  r: 9,
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 400.52004,
  cy: 500.35011,
  rx: 81.96897,
  ry: 17.10011,
  fill: "#e6e6e6"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 402.83987,
  cy: 500.20354,
  rx: 55.60472,
  ry: 9.21789,
  fill: "#ccc"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 217.51989,
  cy: 587.35296,
  rx: 93.55162,
  ry: 19.51645,
  fill: "#e6e6e6"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 598.52004,
  cy: 611.35011,
  rx: 139.49068,
  ry: 29.10011,
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 217.23515,
  cy: 586.72566,
  rx: 71.71091,
  ry: 11.88791,
  fill: "#ccc"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 598.55079,
  cy: 609.50147,
  rx: 122.60253,
  ry: 20.32448,
  fill: "#ccc"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 57.78678,
  cy: 319,
  r: 7,
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 547.78678,
  cy: 421,
  r: 7,
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M513.93275,321.83021c0,17.67312,16.34161,15,36.5,15s36.5,2.67312,36.5-15-7.98246-49-36.5-49C520.93275,272.83021,513.93275,304.1571,513.93275,321.83021Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#2f2e41"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "ArmRight_1",
  d: "M469.20727,471.48346a10.7427,10.7427,0,0,1,6.25283-15.23974l41.81615-88.45906,19.12793,13.413-47.1186,82.7347a10.80091,10.80091,0,0,1-20.07831,7.551Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#ffb8b8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M505.03921,379.529a4.81164,4.81164,0,0,1,.55208-3.97272l13.00138-20.38209a13.37737,13.37737,0,0,1,24.45588,10.84991l-6.54916,23.35316a4.81687,4.81687,0,0,1-6.60409,3.09631l-22.20856-9.93086A4.81147,4.81147,0,0,1,505.03921,379.529Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#5958a5"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "415.837 517.679 404.317 521.874 382.656 479.436 399.658 473.245 415.837 517.679",
  id: "Leg_1",
  fill: "#ffb8b8"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M602.38527,644.38105h23.64386a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H587.49841a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,602.38527,644.38105Z",
  transform: "translate(-391.60407 122.17551) rotate(-20.00652)",
  fill: "#2f2e41"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M589.601,615.5854l-43.88711-76.802a4.822,4.822,0,0,1,.052-4.86807l19.76236-32.93709a4.81657,4.81657,0,0,1,8.66076.84148l37.36377,103.46818a4.7986,4.7986,0,0,1-2.46853,5.9897l-13.23928,6.27089a4.77347,4.77347,0,0,1-2.04387.4589A4.84031,4.84031,0,0,1,589.601,615.5854Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#2f2e41"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  id: "Head_1",
  cx: 343.66191,
  cy: 186.5598,
  r: 24.56103,
  fill: "#ffb8b8"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M513.93993,422.56125c-19.34213-42.88856.15733-66.85886,9.43875-75.17336a14.55691,14.55691,0,0,1,9.73013-3.72135h34.59941a14.576,14.576,0,0,1,13.03753,21.09462l-23.1296,46.25868-43.48806,11.95954Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#5958a5"
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  points: "336.698 529.276 324.438 529.275 318.606 481.987 336.7 481.988 336.698 529.276",
  id: "Leg_2",
  fill: "#ffb8b8"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M315.681,525.77219h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H300.79418a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,315.681,525.77219Z",
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M536.71648,635.97338l-19.62855-2.26417a4.81783,4.81783,0,0,1-4.22285-5.42l17.51831-131.89992a3.75008,3.75008,0,0,0-.07291-1.37669l-17.60769-72.64473a4.761,4.761,0,0,1,.75368-3.92623c2.73039-3.76421,12.08577-12.53657,39.91436-12.70277h.03005a4.83433,4.83433,0,0,1,4.39715,2.82655l3.71221,8.16607a3.76282,3.76282,0,0,0,1.25282,1.51258c5.10954,3.61682,29.862,23.918,15.32783,68.48853C563.806,530.54,545.50373,615.58749,541.97968,632.1914a4.7913,4.7913,0,0,1-4.69768,3.81438A4.92486,4.92486,0,0,1,536.71648,635.97338Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "ArmLeft_1",
  d: "M634.35477,317.47444a10.5273,10.5273,0,0,0,.27256,1.63494l-33.34714,36.70773-11.77758-2.5383-6.1539,17.27378,20.4132,6.5198A8,8,0,0,0,612.831,373.921l31.52107-46.79546a10.4971,10.4971,0,1,0-9.99733-9.65111Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#ffb8b8"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M600.27071,357.37308l-7.73115,21.37219a4.5,4.5,0,0,1-6.36573,2.431L566.226,370.42919A12.49741,12.49741,0,0,1,574.79718,346.95l22.13624,4.48211a4.5,4.5,0,0,1,3.33729,5.94094Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#5958a5"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M578.93275,309.83019v0H569.2184l-4.28565-12-.85693,12h-4.64307l-2.5-7-.5,7h-34.5v0a26,26,0,0,1,26-26h5A26,26,0,0,1,578.93275,309.83019Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M319.5,566.75H316v-3.5a4.5,4.5,0,0,0-9,0v3.5h-3.5a4.5,4.5,0,0,0,0,9H307v3.5a4.5,4.5,0,0,0,9,0v-3.5h3.5a4.5,4.5,0,0,0,0-9Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#ffffff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M834.66,480.91h-1.82v-1.82a2.34,2.34,0,0,0-4.68,0v1.82h-1.82a2.34,2.34,0,0,0,0,4.68h1.82v1.82a2.34,2.34,0,0,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#fff"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M303.66,359.91h-1.82v-1.82a2.34,2.34,0,1,0-4.68,0v1.82h-1.82a2.34,2.34,0,1,0,0,4.68h1.82v1.82a2.34,2.34,0,1,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M438.66,359.91h-1.82v-1.82a2.34,2.34,0,1,0-4.68,0v1.82h-1.82a2.34,2.34,0,1,0,0,4.68h1.82v1.82a2.34,2.34,0,1,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M903.66,599.91h-1.82v-1.82a2.34,2.34,0,0,0-4.68,0v1.82h-1.82a2.34,2.34,0,0,0,0,4.68h1.82v1.82a2.34,2.34,0,0,0,4.68,0v-1.82h1.82a2.34,2.34,0,0,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#F7F115"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M693.66,404.91h-1.82v-1.82a2.34,2.34,0,0,0-4.68,0v1.82h-1.82a2.34,2.34,0,0,0,0,4.68h1.82v1.82a2.34,2.34,0,0,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#67D2CA"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M372.66,454.91h-1.82v-1.82a2.34,2.34,0,1,0-4.68,0v1.82h-1.82a2.34,2.34,0,1,0,0,4.68h1.82v1.82a2.34,2.34,0,1,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#F7F115"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M378.66,288.91h-1.82v-1.82a2.34,2.34,0,1,0-4.68,0v1.82h-1.82a2.34,2.34,0,1,0,0,4.68h1.82v1.82a2.34,2.34,0,1,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,0-4.68Z",
  transform: "translate(-205.21322 -124.75)",
  fill: "#EE4B51"
});

var SvgSignInImg = function SvgSignInImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "100%",
    height: "100%",
    viewBox: "0 0 781.72275 640.45022",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignInImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-in-img.13624bee.svg";
export { ForwardRef as ReactComponent };